module.exports = __webpack_public_path__ + "static/media/error.772e3ffa.png";